$(() => {

    setupNotificationReadEvent();

    setupEditNotification();

});


let setupNotificationReadEvent = () => {

    if($('#notifications-dropdown').length == 0 && $('#notification-popup').length == 0) { return false; }

    
    //#region /****** HANDLERS ******/
    let unreadNotificationCount = $('#notifications-dropdown').attr('data-unreadNotificationCount');
    if(unreadNotificationCount > 0) 
    { 
        $('a.notifications-button').click(() => {

            $('a.notifications-button').off('click');

            const ajaxUrl = $('#notifications-dropdown').attr('data-ajaxLink');
            markNotificationsAsRead(ajaxUrl, 'bell');
            
            
            $('a.notifications-button').click(() => {
                
                $('a.notifications-button').off('click');

                $('.notification-to-remove').hide();

                $('.no-notifications-info').removeClass('hide');

            });

        });
    }


    $('#notification-popup').on('shown.bs.modal', (e) => {
        const ajaxUrl = $('#notification-popup').attr('data-ajaxLink');
        markNotificationsAsRead(ajaxUrl, 'popup');
    })
    //#endregion




    let markNotificationsAsRead = (url, bellOrPopup = 'bell') => {

        $.post({ 
            "url": url,
            "data": {'bellOrPopup': bellOrPopup},
            success: (data) => 
            {
                if(!data.isSuccess) { return false; }
            

                if(bellOrPopup == 'bell') 
                {
                    $('.notifications-dropdown .bell-number').hide();
                }
            },
        });

    }

    

}

let setupEditNotification = () => {

    if($('.editNotification').length == 0) { return false; }

    let formName = '#frm-CrmNotificationsForm-form-';
    
    $('.editNotification').click((event) => {
        
        let notificationInfo = $(event.target);
        
        $(formName + 'id').val(notificationInfo.attr('data-id'));

        $(formName + 'type option[value="' + notificationInfo.attr('data-type') + '"]').attr("selected", "selected");

        $(formName + 'header').val(notificationInfo.attr('data-header'));
        $(formName + 'content').text(notificationInfo.attr('data-content'));
        $(formName + 'showPopup').prop('checked', notificationInfo.attr('data-showPopup'));


        audiences = JSON.parse(notificationInfo.attr('data-audience'));
        
        audiences.forEach(audienceName => {
            $(formName + 'audience-' + audienceName).prop('checked', true);
        });


        location.hash = "";
        location.hash = "form";

    });

}